import React from "react";
import { Row, Col } from "antd";
import { CustomCard } from "react_reusable_components";
import Styles from "./subCategoryStyles.module.scss";

const SubCategoryCardContainer = ({ subCategory }) => {
  return (
    <Row className={Styles["cards-wrapper"]} gutter={[16, 16]}>
      {subCategory?.map((subCategoryItem) => (
        <Col key={subCategoryItem.id} xs={24} sm={12} md={8} lg={8} xl={8}>
          <CustomCard
            heading={subCategoryItem?.name}
            description={
                subCategoryItem?.country?.map((country, index) => {
                  if (country?.isActive) {
                    return (
                      country?.name +
                      (index !== subCategoryItem.country.length - 1 ? "," : "")
                    );
                  } else {
                    return (
                      <span key={country?.name} style={{ opacity: "0.5" }}>
                        {country?.name +
                          (index !== subCategoryItem.country.length - 1
                            ? ","
                            : "")}
                      </span>
                    );
                  }
                })
            }
          />
        </Col>
      ))}
    </Row>
  );
};

export default SubCategoryCardContainer;
